export enum RoleModuleAccessLevel {
	READ = "READ",
	READ_WRITE = "READ_WRITE",
	APPROVE = "APPROVE",
}

/** Highest access the module catalog allows (`GET /role-modules`). */
export type RoleModuleCapabilityMask =
	| RoleModuleAccessLevel.READ_WRITE
	| RoleModuleAccessLevel.APPROVE;

export interface RoleModule {
	id: string;
	code: string;
	name: string;
	permissionMask: RoleModuleCapabilityMask;
}

export interface RolePermission {
	id: string;
	moduleId: string;
	accessLevel: RoleModuleAccessLevel;
	module: RoleModule;
}

export interface RoleListItem {
	id: string;
	name: string;
	description: string | null;
	isActive: boolean;
	permissions: RolePermission[];
}
